// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__y0eLq","tabText":"Menu_tabText__1p3vj","carSale":"Menu_carSale__BiEWi"};